/** Format a number with Turkish locale thousand separators (. for thousands, , for decimals).
 *  Returns empty string for null/undefined so fallback || works. */
export const fmtTR = (value: number | undefined | null, decimals: number = 2): string => {
  if (value == null || isNaN(value)) return '';
  return value.toLocaleString('tr-TR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};
